import React, { useEffect, useState } from "react";
import s from "./styles.module.css";

const EditPhotoUploader = ({
  existingPhotos = [], // массив объектов с id и image_url
  onPhotosChange,
  photoError,
  setPhotoError,
  onRemoveExistingPhoto,
}) => {
  // newPhotos – новые выбранные файлы
  const [newPhotos, setNewPhotos] = useState([]);
  // localPhotos – объединённый список для отображения (с существующими и новыми)
  const [localPhotos, setLocalPhotos] = useState([]);

  // При инициализации компонента заполняем localPhotos уже существующими фото
  useEffect(() => {
    setLocalPhotos(existingPhotos);
  }, [existingPhotos]);

  // При выборе новых файлов добавляем их
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const updatedNewPhotos = [...newPhotos, ...files];
    setNewPhotos(updatedNewPhotos);
    setLocalPhotos((prev) => [...prev, ...files]);

    onPhotosChange && onPhotosChange(updatedNewPhotos);
    if (updatedNewPhotos.length + existingPhotos.length > 0) {
      setPhotoError("");
    }
  };

  // При удалении фото определяем, является ли оно существующим (объект с image_url) или новым (File)
  const handleRemovePhoto = (index) => {
    const photoToRemove = localPhotos[index];
    let updatedLocalPhotos = [...localPhotos];
    updatedLocalPhotos.splice(index, 1);
    setLocalPhotos(updatedLocalPhotos);

    // Если удаляется новый файл, обновляем newPhotos
    if (photoToRemove instanceof File) {
      const updatedNewPhotos = newPhotos.filter(
        (photo) => photo !== photoToRemove,
      );
      setNewPhotos(updatedNewPhotos);
      onPhotosChange && onPhotosChange(updatedNewPhotos);
    } else {
      onRemoveExistingPhoto && onRemoveExistingPhoto(photoToRemove.id);
    }
  };

  return (
    <div className={s.photoUploaderMain}>
      <h1>Фото объявления</h1>
      <div className={s.photoUploaderGrid}>
        {localPhotos.map((photo, index) => (
          <div key={index} className={s.photoPreviewItem}>
            <img
              className={s.photoImage}
              src={
                photo instanceof File
                  ? URL.createObjectURL(photo)
                  : `${process.env.REACT_APP_API_URL}/api/v1/property/${photo.image_url.replace("/photos/", "")}`
              }
              alt={`Фото ${index + 1}`}
            />
            <button
              type="button"
              className={s.removePhotoButton}
              onClick={() => handleRemovePhoto(index)}
            >
              ✖
            </button>
          </div>
        ))}

        {/* Блок загрузки */}
        <div className={s.photoUploaderContainer}>
          <label className={s.uploadBoxWrapper}>
            <input
              type="file"
              multiple
              accept="image/*"
              onChange={handleFileChange}
              hidden
            />
            <img src="/plus.svg" alt="Добавить фото" />
          </label>
          <p>Нажмите и добавьте изображение</p>
        </div>
      </div>
      {photoError && <p className={s.errorText}>{photoError}</p>}
    </div>
  );
};

export default EditPhotoUploader;
